Drupal.behaviors.toybox_banner_slider = {
  // eslint-disable-next-line no-unused-vars
  attach: function (context, settings) {
    var bannerSliders = document.querySelectorAll(".js-banner-slider");

    // eslint-disable-next-line no-unused-vars
    bannerSliders.forEach((bannerSlider, index) => {
      // eslint-disable-next-line no-unused-vars, no-undef
      var swiper = new Swiper(bannerSlider, {
        slidesPerView: "auto",
        CSSWidthAndHeight: true,
        centeredSlides: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: null,
          nextEl: null,
        },
      });
    });
  },
};
